export enum OnlineBookingStatus {
  Pending = "Pending",
  Confirmed = "Confirmed",
  Declined = "Declined",
}

export type IOnlineBookingEntity = {
  id: string;
  applicationId: number;
  inspectionType: string;
  location: string;
  siteContactName: string;
  notes: string;
  bookingTime: string;
  status: OnlineBookingStatus;
};

export const OnlineBookingStatusUtil = {
  parse: (str: string): OnlineBookingStatus => {
    for (const value of Object.values(OnlineBookingStatus)) {
      if (str.toLowerCase() === value.toString().toLowerCase()) {
        return value;
      }
    }
    return OnlineBookingStatus.Pending;
  },
};
